import React, {Fragment, useCallback, useState} from 'react';
import {TabContent, TabPane} from 'reactstrap';
import {H5} from '../../AbstractElements';
import CheckLayout from './Tabs/CheckLayout';
import SidebarCusmizer from './Tabs/Sidebar';

const TabCustomizer = ({selected, callbackNavTab}) => {
    const [modal, setModal] = useState(false);
    const toggle = useCallback(() => {
        setModal(!modal);
    }, [modal]);

    return (
        <Fragment>
            <TabContent activeTab={selected}>
                <div className="customizer-header">
                    <i className="icon-close" onClick={() => callbackNavTab('', false)}></i>
                    <H5>{'PREVIEW SETTINGS'}</H5>
                </div>
                <div className="customizer-body custom-scrollbar tab-content">
                    <TabPane tabId="check-layout">
                        <CheckLayout/>
                    </TabPane>
                    <TabPane tabId="sidebar-type">
                        <SidebarCusmizer/>
                    </TabPane>
                </div>
            </TabContent>
        </Fragment>
    );
};

export default TabCustomizer;